<template>
  <div id="app" ref="app">
    <Notifications />
    <BLoading is-full-page :active="isSectionLoading" />
    <RouterView />
    <MediaPlayerModal />
    <MessagePremiumV2 :title="'FUNCIONALIDAD PREMIUM'" />
    <CreatePlaylistModal />
    <ModalLogin />
    <ModalNewApp
      :isModalOpen="isModalNewAppVisible"
      :isIOSMobile="isIOSMobile"
      @close="isModalNewAppVisible = false"
      @click-store="onClickStore"
    />
    <!-- Modal para los Videos -->
    <BModal
      :active.sync="isVideoModalVisibleComp"
      trap-focus
      class="modal-video"
      :destroy-on-hide="true"
      aria-role="dialog"
      aria-modal
      :can-cancel="['outside', 'escape']"
    >
      <VideoModal :src="videoSrc" @onClickClose="onClickCloseOnModalVideo" />
    </BModal>

  </div>
</template>

<script>
import store from '@/store';
import { mapState, mapMutations, mapActions } from 'vuex';
import { loginAndPageLoad } from '@/utils/api/activity-tracking';
import { getMobileOperatingSystem, getIsMobileOrTablet } from '@/utils/misc';

export default {
  name: 'GolStats',
  components: {
    Notifications: () => import('@/components/Modals/Notifications'),
    ModalLogin: () => import('@/views/Auth/ModalIndex'),
    ModalNewApp: () => import('@/components/Modals/ModalNewApp'),
    // MediaPlayerModal: () => import('@/components/Modals/MediaPlayerModal'),
    MediaPlayerModal: () => import('@/components/Sections/MediaPlayer-v3/MediaPlayerModal'),
    CreatePlaylistModal: () => import('@/components/Sections/MediaPlayer-v3/CreatePlaylistModal'),
    VideoModal: () => import('@/components/Modals/Video'),
    MessagePremiumV2: () => import('@/components/Elements/MessagePremiumV2'),

  },
  data() {
    return {
      isModalNewAppVisible: false,
      isIOSMobile: false,
    };
  },
  store,
  watch: {
    currentLanguage: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue !== oldValue && this.$i18n.locale !== newValue) {
          this.$i18n.locale = newValue;
        }
      },
    },
    $route(to) {
      if (!this.booleanIsGSBehavior) {
        if (window.sessionStorage.getItem('IsWidget') === null) {
          if (window.localStorage.getItem('user')) {
            let user = window.localStorage.getItem('user');
            user = JSON.parse(window.atob(user));
            if (!to.name) {
              if (user.userType == 0) {
                this.$router.push('/bets');
              } else {
                this.$router.push('/landing');
              }
            } else {
              if (to.name == 'landing') {
                if (user.userType == 0) {
                  this.$router.push('/bets');
                }
              } else if (to.name == 'bets') {
                if (user.userType == 1) {
                  this.$router.push('/landing');
                }
              }
            }
          }
        } else {
          if (to.name == 'widget' || to.name.indexOf('widget') > -1) {
            this.$router.push('/widget/' + window.sessionStorage.getItem('WidgetTeam'));
          } else {
            if (window.sessionStorage.getItem('IsWidget') === null) {
              if (window.localStorage.getItem('user')) {
                let user = window.localStorage.getItem('user');
                user = JSON.parse(window.atob(user));
                if (user.userType == 0) {
                  this.$router.push('/bets');
                } else {
                  this.$router.push('/landing');
                }
              }
            } else {
              let user = window.localStorage.getItem('user');
              user = JSON.parse(window.atob(user));
              if (user.premiumAccount) {
                if (to.name == 'bets' || to.name == 'landingV2') {
                  if (user.userType == 0) {
                    this.$router.push('/widget/' + window.sessionStorage.getItem('WidgetTeam'));
                  } else {
                    this.$router.push('/landing');
                  }
                }
              }
            }
          }
        }
      }
    },
  },
  created() {
    window.addEventListener('resize', () => {
      this.$store.commit('setWindowWidth');
    });
    this.setUpHotJar();
  },
  mounted() {
    this.checkAppNavigation();
    this.$store.commit('setWindowWidth', this.$refs.app.clientWidth);
    this.setUpCountryInfo();
    this.showNewAppModal();
  },
  computed: {
    ...mapActions('loginGeneral', ['getUserInfoLocal', 'getPremiumAccount']),
    ...mapState(['isSectionLoading']),
    ...mapState('general', ['videoSrc', 'isVideoModalVisible']),
    ...mapState('loginGeneral', ['currentLanguage', 'booleanIsGSBehavior']),
    isVideoModalVisibleComp: {
      get() {
        return this.isVideoModalVisible;
      },
      set(nv) {
        this.setVideoModalVisibility(nv);
      },
    },
  },
  methods: {
    ...mapMutations('general', ['setVideoModalVisibility']),
    ...mapMutations('loginGeneral', ['setBooleanIsFromMexico']),
    showNewAppModal() {
      const isMobile = getIsMobileOrTablet()
      const isFromApp = window.localStorage.getItem('isFromApp') ? true : false

      this.isIOSMobile = getMobileOperatingSystem() === 'iOS';
      this.isModalNewAppVisible = isMobile && isFromApp ? true : false;
    },
    onClickStore(storeBrand) {
      let storeUrl = '';
      if (storeBrand === 'iOS') {
        storeUrl = 'https://apps.apple.com/mx/app/golstats/id979011901';
      } else {
        storeUrl = 'https://play.google.com/store/apps/details?id=com.golstats';
      }
      window.location.href = storeUrl;
    },
    async setUpCountryInfo() {
      try {
        const response = await fetch('https://ipapi.co/json/');
        const responseJson = await response.json();
        this.setBooleanIsFromMexico(responseJson ? responseJson.country === 'MX' : true);
      } catch (e) {
        throw new Error(e);
      }
    },
    checkAppNavigation() {
      let stringNavigationType = '';
      const observer = new PerformanceObserver(list => {
        list.getEntries().forEach(entry => {
          if (!stringNavigationType) {
            stringNavigationType = entry.type === 'reload' ? 'refresh' : 'recurrente';
            const stringEncodedUser = window.localStorage.getItem('user');
            if (stringEncodedUser) {
              const objectDecodedUser = JSON.parse(window.atob(stringEncodedUser));
              loginAndPageLoad({
                numberUserId: objectDecodedUser.id,
                objectMetadata: {
                  stringOrigin: window.localStorage.getItem('isFromApp') ? 'app' : 'web',
                  stringType: stringNavigationType,
                },
              });
            }
          }
        });
      });

      observer.observe({ type: 'navigation', buffered: true });
    },
    setUpHotJar() {
      const origin = window.location.origin;
      let hotJarId = null;
      if (origin.includes('//falcon-2.golstats.com/')) {
        hotJarId = 2956982;
      }
      if (hotJarId) {
        this.hotJarFunction(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=', null, null, hotJarId);
      }
    },
    hotJarFunction(h, o, t, j, a, r, hotJarId) {
      h.hj =
        h.hj ||
        function() {
          (h.hj.q = h.hj.q || []).push(arguments);
        };
      h._hjSettings = { hjid: hotJarId, hjsv: 6 };
      // eslint-disable-next-line no-param-reassign
      a = o.getElementsByTagName('head')[0];
      // eslint-disable-next-line no-param-reassign
      r = o.createElement('script');
      r.async = 1;
      r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
      a.appendChild(r);
    },
    onClickCloseOnModalVideo() {
      this.isVideoModalVisibleComp = false;
    },
  },
};
</script>

<style lang="scss">
.modal-video.modal {
  z-index: 1002 !important;
}
.is-gs-bordered {
  border-radius: 21px;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.26);
  background-color: #ffffff;
}
.select:not(.is-multiple):not(.is-loading)::after {
  border-color: #7ed321 !important;
}
/* Estilos para titulos */
.title-wrapper {
  font-family: 'Circular-Std';
  display: flex;
  align-items: center;
  justify-content: center;
}
.title-wrapper {
  &.black {
    color: black;
  }
  &.left {
    justify-content: flex-start;

    & span {
      margin-left: 0.4rem;
    }
  }
  &.right {
    justify-content: flex-end;
  }

  & img {
    width: 4.5rem;
    height: 4.5rem;

    @media (max-width: 400px) {
      width: 2rem;
      height: 2rem;
    }
  }
}
</style>
